import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Refresh } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { Portal } from "@air/primitive-portal";
export const ReloadApplicationPrompt = (param)=>{
    let { onReload } = param;
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "absolute bottom-6 left-6 flex w-full max-w-[224px] flex-col gap-4 rounded-lg bg-grey-1 p-4 shadow-popover",
            children: [
                /*#__PURE__*/ _jsxs("header", {
                    className: "flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-14 font-semibold text-grey-12",
                            children: "Air has an update!"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-12 text-grey-10",
                            children: "Click to refresh."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("footer", {
                    className: "flex flex-col items-stretch",
                    children: /*#__PURE__*/ _jsx(Button, {
                        appearance: "filled",
                        color: "blue",
                        onClick: onReload,
                        prefix: /*#__PURE__*/ _jsx(Refresh, {
                            className: "size-4"
                        }),
                        children: "Refresh now"
                    })
                })
            ]
        })
    });
};
